import { render, staticRenderFns } from "./AboutEmployees.vue?vue&type=template&id=621a6ad1&scoped=true&"
import script from "./AboutEmployees.vue?vue&type=script&lang=js&"
export * from "./AboutEmployees.vue?vue&type=script&lang=js&"
import style0 from "./AboutEmployees.vue?vue&type=style&index=0&id=621a6ad1&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "621a6ad1",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VImg } from 'vuetify/lib/components/VImg';
import { VLayout } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VCardText,VContainer,VFlex,VIcon,VImg,VLayout})
